import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaSaldos', {
    controller: nominasNominaSaldosComponent,
    template: template,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
    },
  })

function nominasNominaSaldosComponent(NominasNominaSaldos) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.actualizar = actualizar
  $ctrl.exportar = exportar
  $ctrl.filtrar = filtrar
  $ctrl.filtro = ''

  function $onInit() {
    $ctrl.nominaSaldos = undefined

    return NominasNominaSaldos.get($ctrl.idEmpresa, $ctrl.idNomina)
      .then(function (response) {
        $ctrl.nominaSaldos = response
        $ctrl.grid = $ctrl.nominaSaldos.generarGrid()
      })
  }

  function actualizar(data) {
    let item = $ctrl.nominaSaldos.editando.item

    if (item && data) {
      let origen = data.id_moneda === 1 ? 'usd_' : 'mxn_',
        destino = data.id_moneda === 1 ? 'mxn_' : 'usd_'

      item[origen + 'descuentos'] = redondear(item[origen + 'descuentos'] + data.cargos)
      item[origen + 'total'] = redondear(item[origen + 'neto'] - item[origen + 'descuentos'])
      item[destino + 'saldo'] = redondear(item[destino + 'saldo'] - data.abonos)

      $ctrl.grid.api.refreshView()
    }

    $ctrl.nominaSaldos.editando = null
  }

  function exportar() {
    if ($ctrl.nominaSaldos)
      $ctrl.nominaSaldos.exportarXLS()
  }

  function filtrar() {
    $ctrl.grid.api.setQuickFilter($ctrl.filtro)
  }

  function redondear(numero) {
    return parseFloat(numero.toFixed(2))
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/saldos/component.js